import React from 'react';
import LzCModuleChildBase, { LzIModuleChildBase } from './ModuleChildBase';

export interface LzIPage extends LzIModuleChildBase {
    /**
     * Children content or component for this page.
     * If not defined, then it will be assumed that this `Page` is just a link to some other inside route or outside url.
     */
    children?: React.ReactNode | undefined;
}

class LzCPage extends LzCModuleChildBase implements LzIPage {
    children: React.ReactNode | undefined;

    constructor(model?: LzIPage) {
        super(model);

        this.variation = 'Page';

        this.children = model?.children;
    }
}

export default LzCPage;
